import { RootState } from 'store';
import { useSelector } from 'react-redux';

import { STATE } from '../types/state';
import {
  checkIsLoading,
  checkIsLoadingDone,
  checkIsLoadingError,
} from 'common/utils/checkLoading';
import { FuelCard } from 'dataSources/Typicode/fuelCards';

export const useFuelCardsData = () => {
  const result = useSelector((state: RootState) => state[STATE].fuelCards.data);

  return result;
};

export const useFuelCardsStatusLoading = () => {
  const result = useSelector(
    (state: RootState) => state[STATE].fuelCards.statusLoading,
  );

  return result;
};

export const useFuelCard = (cardNumber: string) => {
  const result = useSelector(
    (state: RootState) => state[STATE].fuelCards.data[cardNumber],
  );

  return result;
};

export const useActiveFuelCard = () => {
  const result = useSelector(
    (state: RootState) => state[STATE].fuelCards.activeFuelCard,
  );

  return result;
};

export const useFuelCards = () => {
  const result = useSelector(
    (state: RootState) =>
      Object.values(state[STATE].fuelCards.data) as FuelCard[],
  );

  return result;
};

export const isFuelCardsLoading = () => {
  const status = useFuelCardsStatusLoading();
  return checkIsLoading(status);
};

export const isFuelCardsDataLoaded = () => {
  const status = useFuelCardsStatusLoading();
  return checkIsLoadingDone(status);
};

export const isFuelCardsDataError = () => {
  const status = useFuelCardsStatusLoading();
  return checkIsLoadingError(status);
};
